namespace RioERP.Orders {
    export namespace OrdersService {
        export const baseUrl = 'Orders/Orders';

        export declare function Create(request: Serenity.SaveRequest<OrdersRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<OrdersRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<OrdersRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<OrdersRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ReCalculate(request: string[], onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ReCalculateFranchisee(request: string[], onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetDetail(request: ExcelImportRequest, onSuccess?: (response: ExcelImportResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function SendEmails(request: OrderEmailRequest, onSuccess?: (response: ExcelImportResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ProcessOrder(request: string[], onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ExcelImport(request: ExcelImportRequest, onSuccess?: (response: ExcelImportResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ExcelImportForShipping(request: ExcelImportRequest, onSuccess?: (response: ExcelImportResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function ScanBook(request: ScanBookRequest1, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Orders/Orders/Create",
            Update = "Orders/Orders/Update",
            Delete = "Orders/Orders/Delete",
            Retrieve = "Orders/Orders/Retrieve",
            List = "Orders/Orders/List",
            ReCalculate = "Orders/Orders/ReCalculate",
            ReCalculateFranchisee = "Orders/Orders/ReCalculateFranchisee",
            GetDetail = "Orders/Orders/GetDetail",
            SendEmails = "Orders/Orders/SendEmails",
            ProcessOrder = "Orders/Orders/ProcessOrder",
            ExcelImport = "Orders/Orders/ExcelImport",
            ExcelImportForShipping = "Orders/Orders/ExcelImportForShipping",
            ScanBook = "Orders/Orders/ScanBook"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List', 
            'ReCalculate', 
            'ReCalculateFranchisee', 
            'GetDetail', 
            'SendEmails', 
            'ProcessOrder', 
            'ExcelImport', 
            'ExcelImportForShipping', 
            'ScanBook'
        ].forEach(x => {
            (<any>OrdersService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
